
import WebsiteRoutes from "../apiRoutes/WebsiteRoutes";
import { GET, POST, POST_JSON } from "./ConsumeApiController";

import { loadStripe } from "@stripe/stripe-js";

const stripe = loadStripe('pk_test_tXggoq3rcB1QHynt7CZ3ZVg400NUsXP6Ue');

export async function CreatePaymentIntent(amount,merchant_id,customer) {
    const params = [
        {name:'amount',value:amount},
        {name:'merchant_id',value:merchant_id}
    ];

    let response = await POST_JSON(
        WebsiteRoutes.Stripe.createPaymentIntent,
        {
            amount,
            merchant_id,
            customer
        }
    );
    return response;
}


export async function paymentProcess(amount,payment_method_id,account_number_id,bank_id,currency_id,create_real_date,customer) {

    let response = await POST_JSON(
        WebsiteRoutes.Stripe.paymentProccess,
        {
            amount,
            payment_method_id,
            account_number_id,
            bank_id,
            currency_id,
            currency:'usd',
            gateway_id:'WEB',
            create_real_date,
            transaction_type_id:1, //cambiar a 1 para produccion
            //merchant_id,
            customer,
            provider: 'stripe'
        }
    );
    return response;
}

export async function createPayment()
{
    
}



export async function paymentProcessBancoPlaza(amount,payment_method_id,account_number_id,bank_id,currency_id,create_real_date,customer,banco,telefonoCliente,referencia,amount_ves) {

    let response = await POST_JSON(
        WebsiteRoutes.Stripe.paymentProccess,
        {
            amount,
            payment_method_id,
            account_number_id,
            bank_id,
            currency_id,
            currency:'usd',
            gateway_id:'WEB',
            create_real_date,
            transaction_type_id:1, //cambiar a 1 para produccion
            //merchant_id,
            customer,
            provider: 'bancoplaza',
            banco,
            telefonoCliente,
            referencia,
            amount_ves
        }
    );
    return response;
}